module.exports = __webpack_public_path__ + "static/media/31praia.29f6b0ca.mp3";